import { render, staticRenderFns } from "./EmployeePayAdjustmentApproval.vue?vue&type=template&id=48eb037f"
import script from "./EmployeePayAdjustmentApproval.vue?vue&type=script&lang=js"
export * from "./EmployeePayAdjustmentApproval.vue?vue&type=script&lang=js"
import style0 from "./EmployeePayAdjustmentApproval.vue?vue&type=style&index=0&id=48eb037f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports